import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
    return (
        <>
            <section className="notfound">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mx-auto">
                            <div className="my-2">
                                <img className="notfound-img" src="https://github.com/wdkabir/mdkabir-portfolio-images/blob/main/page-not-found.png?raw=true" alt="Page Not Found" />
                            </div>
                            <div className="my-3 mx-auto text-center">
                                <Link to="/">
                                    <Button className="fs-5 fw-bolder" style={{backgroundImage: 'linear-gradient(90deg,#f61b10,#ef0963)', border: 'none'}}>
                                        Back To Home
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default NotFound;